import React from 'react'
import type { PresentationBlock } from 'paintscout'

import { ButtonSelectOption, ButtonOption } from '../../components'
import makeRowHandlers from '../../util/makeRowHandlers'

import VerticalAlignTopIcon from '@material-ui/icons/VerticalAlignTop'
import VerticalAlignCenterIcon from '@material-ui/icons/VerticalAlignCenter'
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom'
import AddIcon from '@material-ui/icons/Add'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'

interface ServicesOptionsProps {
  block: PresentationBlock
  handleOptionFieldChange: (field: string, value: any) => void
}

function ServicesOptions(props: ServicesOptionsProps) {
  const { block, handleOptionFieldChange } = props
  const { alignment, rows, width } = block.fields

  const { handleAddRow, handleRemoveLastRow } = makeRowHandlers({
    rows,
    newRow: { title: '', content: '', image: null },
    handleOptionFieldChange
  })

  const options = [
    {
      Component: (
        <ButtonSelectOption
          label={'Image Size'}
          value={width ?? 'default'}
          buttons={[
            { icon: 'S', value: 'small' },
            { icon: 'M', value: 'medium' },
            { icon: 'L', value: 'large' }
          ]}
          onChange={(value) => handleOptionFieldChange('fields.width', value)}
        />
      ),
      tab: 'content'
    },
    {
      Component: (
        <ButtonSelectOption
          label={'Vertical Alignment'}
          value={alignment ?? 'center'}
          buttons={[
            { icon: <VerticalAlignTopIcon />, value: 'top' },
            { icon: <VerticalAlignCenterIcon />, value: 'center' },
            { icon: <VerticalAlignBottomIcon />, value: 'bottom' }
          ]}
          onChange={(value) => handleOptionFieldChange('fields.alignment', value)}
        />
      ),
      tab: 'content'
    },
    {
      Component: (
        <ButtonOption
          label={'Rows'}
          buttons={[
            { icon: <AddIcon />, onClick: handleAddRow },
            ...(rows?.length ? [{ icon: <DeleteOutlineIcon />, onClick: handleRemoveLastRow }] : [])
          ]}
        />
      ),
      tab: 'content'
    }
  ]

  return options
}

export default ServicesOptions
